<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
const url =
  process.env.NODE_ENV == "development"
    ? "https://hm.baidu.com/hm.js?00d6ed804dc8b91a073d5f2da91084b8"
    : "https://hm.baidu.com/hm.js?bb0770d1248b6b3b2473db05d9c66141";
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = url;
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
export default {
  name: "App",
  data() {
    return {};
  },
};
</script>
<style lang="scss">
html {
  margin: 0px;
}
body {
  margin: 0px;
  background-color: #f4f6f9;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
#app {
  font-family: "微软雅黑", "Avenir", Helvetica, Arial, sans-serif;
}
/*基本元素*/
/*html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, ab, dl, dt, dd, ol, ul, li, img, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td*/
/*{margin: 0;padding: 0;border: 0;outline: 0;vertical-align: baseline;}*/
/*img { -ms-interpolation-mode: bicubic; border:0; margin:0;vertical-align:bottom;}*/
/*a{ color:#000;  text-decoration:none; cursor:pointer;}*/
/*a:hover{ color:#e3ac2e;  text-decoration:none; }*/
/*p {text-decoration:none;}*/
body {
  font-family: "微软雅黑";
}
p {
  margin: 0;
}
.clear {
  clear: both;
}
/*h1 { font-size:12px;}*/
/*li { list-style-type:none;}*/
/* 通用 */
.layout {
  width: 1200px;
  margin: 0 auto;
}
.font_blue {
  color: #2c91ff;
}
.font_ccc {
  color: #ccc;
}
.font_a3a3a3 {
  color: #a3a3a3;
}
.font_fff {
  color: #fff;
}
</style>
